import MapServiceModel from '@/models/MapServiceModel';
import doc             from '@widesk-core/decorators/doc';
import { jwtDecode }   from 'jwt-decode';
import { computed }    from 'mobx';
import dayjs           from 'dayjs';

@doc.path('/maps/{id}/mercure')
export default class MapMercureModel extends MapServiceModel {
	@computed get data(): Record<string, unknown> {
		return jwtDecode(this.jwt);
	}

	@computed get exp() {
		return dayjs(this.data?.exp as number * 1000 || 0);
	}

	@computed get jwt(): string {
		return this.get('token', '');
	}
}
